
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[target]/[product]/[brand]/[code]",
      function () {
        return require("private-next-pages/[target]/[product]/[brand]/[code].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[target]/[product]/[brand]/[code]"])
      });
    }
  